(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-derm-cert-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-nc-cert-catalog]').forEach(function (root) {
      var cards = Array.from(root.querySelectorAll('[data-nc-course-card]'));
      var teamCard = root.querySelector('[data-nc-team-card]');
      var countEl = root.querySelector('[data-nc-results-count]');
      var chipsEl = root.querySelector('[data-nc-chips]');
      var emptyEl = root.querySelector('[data-nc-empty]');
      var sortEl = root.querySelector('[data-nc-sort]');
      var grid = root.querySelector('[data-nc-grid]');
      var total = cards.length;

      var filterLabels = {};
      root.querySelectorAll('[data-nc-filter]').forEach(function (input) {
        var key = input.getAttribute('data-nc-filter') + ':' + input.value;
        var text = input.closest('.nc-derm-cert-catalog__option').querySelector('.nc-derm-cert-catalog__option-text').textContent.trim();
        filterLabels[key] = text;
      });

      function parseList(value) {
        return (value || '').split(/[,\s]+/).filter(Boolean);
      }

      function getActiveFilters() {
        var active = { category: [], skill: [], duration: [], concern: [], modality: [], price: [] };
        root.querySelectorAll('[data-nc-filter]:checked').forEach(function (input) {
          var group = input.getAttribute('data-nc-filter');
          active[group].push(input.value);
        });
        return active;
      }

      function cardMatches(card, active) {
        var groups = ['category', 'skill', 'duration', 'concern', 'modality', 'price'];
        for (var i = 0; i < groups.length; i++) {
          var g = groups[i];
          var selected = active[g];
          if (!selected.length) continue;
          if (g === 'category' && selected.indexOf('all') !== -1) continue;
          var cardVals = parseList(card.getAttribute('data-' + (g === 'price' ? 'price-tier' : g)));
          if (!cardVals.some(function (v) { return selected.indexOf(v) !== -1; })) return false;
        }
        return true;
      }

      function updateCounts() {
        var dims = ['category', 'skill', 'duration', 'concern', 'modality', 'price'];
        dims.forEach(function (dim) {
          root.querySelectorAll('[data-nc-count^="' + dim + '-"]').forEach(function (el) {
            var val = el.getAttribute('data-nc-count').replace(dim + '-', '');
            var n = cards.filter(function (card) {
              var attr = dim === 'price' ? 'data-price-tier' : 'data-' + dim;
              return parseList(card.getAttribute(attr)).indexOf(val) !== -1;
            }).length;
            el.textContent = '(' + n + ')';
          });
        });
      }

      function renderChips(active) {
        chipsEl.innerHTML = '';
        Object.keys(active).forEach(function (group) {
          active[group].forEach(function (val) {
            if (group === 'category' && val === 'all') return;
            var chip = document.createElement('span');
            chip.className = 'nc-derm-cert-catalog__chip';
            chip.innerHTML = '<span>' + (filterLabels[group + ':' + val] || val) + '</span><button type="button" aria-label="Remove filter">&times;</button>';
            chip.querySelector('button').addEventListener('click', function () {
              var input = root.querySelector('[data-nc-filter="' + group + '"][value="' + val + '"]');
              if (input) input.checked = false;
              if (group === 'category' && !root.querySelector('[data-nc-filter="category"]:checked')) {
                var allInput = root.querySelector('[data-nc-filter="category"][value="all"]');
                if (allInput) allInput.checked = true;
              }
              apply();
            });
            chipsEl.appendChild(chip);
          });
        });
      }

      function sortCards() {
        var mode = sortEl ? sortEl.value : 'popular';
        var sorted = cards.slice().sort(function (a, b) {
          if (mode === 'price-asc') return Number(a.getAttribute('data-price')) - Number(b.getAttribute('data-price'));
          if (mode === 'price-desc') return Number(b.getAttribute('data-price')) - Number(a.getAttribute('data-price'));
          if (mode === 'title') return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
          return 0;
        });
        sorted.forEach(function (card) { grid.insertBefore(card, teamCard || emptyEl); });
      }

      function apply() {
        var active = getActiveFilters();
        var visible = 0;
        cards.forEach(function (card) {
          var show = cardMatches(card, active);
          card.hidden = !show;
          if (show) visible++;
        });
        if (countEl) countEl.textContent = 'Showing ' + visible + ' of ' + total + ' courses';
        if (emptyEl) emptyEl.hidden = visible > 0;
        renderChips(active);
      }

      root.querySelector('[data-nc-apply-filters]')?.addEventListener('click', apply);
      root.querySelector('[data-nc-clear-filters]')?.addEventListener('click', function () {
        root.querySelectorAll('[data-nc-filter]').forEach(function (input) {
          input.checked = input.value === 'all' && input.getAttribute('data-nc-filter') === 'category';
        });
        apply();
      });
      root.querySelectorAll('[data-nc-filter]').forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.getAttribute('data-nc-filter') === 'category' && input.value === 'all' && input.checked) {
            root.querySelectorAll('[data-nc-filter="category"]').forEach(function (c) {
              if (c.value !== 'all') c.checked = false;
            });
          }
          if (input.getAttribute('data-nc-filter') === 'category' && input.value !== 'all' && input.checked) {
            var all = root.querySelector('[data-nc-filter="category"][value="all"]');
            if (all) all.checked = false;
          }
        });
      });
      if (sortEl) sortEl.addEventListener('change', function () { sortCards(); apply(); });

      updateCounts();
      sortCards();
      apply();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-derm-cert-tracks"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nc-track-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.closest('[data-nc-track-panel]');
      var body = panel.querySelector('[data-nc-track-body]');
      var label = panel.querySelector('[data-nc-toggle-label]');
      var icon = panel.querySelector('[data-nc-toggle-icon]');
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      body.hidden = open;
      if (label) label.textContent = open ? 'VIEW COURSES' : 'HIDE COURSES';
      if (icon) icon.textContent = open ? '+' : '−';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-derm-featured-provider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (!root || root.dataset.ncFprovInit === '1') return;
      root.dataset.ncFprovInit = '1';

      var cards = root.querySelectorAll('[data-pcard-card]');
      cards.forEach(function (card) {
        var optionsWrap = card.querySelector('[data-pcard-options]');
        var priceEl = card.querySelector('[data-pcard-price]');
        var atcBtn = card.querySelector('[data-pcard-atc]');
        var hiddenId = card.querySelector('[data-pcard-variant-id]');
        if (!optionsWrap || !hiddenId) return;

        var jsonEl = optionsWrap.querySelector('[data-pcard-variants]');
        if (!jsonEl) return;

        var allVariants = [];
        try {
          allVariants = JSON.parse(jsonEl.textContent);
        } catch (e) {
          return;
        }

        var safeIdsStr = optionsWrap.getAttribute('data-safe-ids') || '';
        var safeIds = safeIdsStr
          .split(',')
          .map(function (s) { return parseInt(s.trim(), 10); })
          .filter(function (n) { return !isNaN(n); });

        var poolVariants = allVariants.filter(function (v) {
          return safeIds.indexOf(v.id) !== -1;
        });
        if (poolVariants.length === 0) poolVariants = allVariants.slice();

        var selects = Array.prototype.slice.call(
          optionsWrap.querySelectorAll('[data-pcard-option-select]')
        );

        function currentSelection() {
          return selects.map(function (sel) { return sel.value; });
        }

        function findMatch(selection) {
          for (var i = 0; i < poolVariants.length; i++) {
            var v = poolVariants[i];
            var ok = true;
            for (var j = 0; j < selection.length; j++) {
              if (v.options[j] !== selection[j]) { ok = false; break; }
            }
            if (ok) return v;
          }
          return null;
        }

        function setActiveVariant(v) {
          if (!v) {
            if (atcBtn) {
              atcBtn.disabled = true;
              atcBtn.textContent = 'Unavailable';
            }
            return;
          }
          hiddenId.value = String(v.id);
          if (priceEl) priceEl.textContent = formatMoney(v.price);
          if (atcBtn) {
            atcBtn.disabled = !v.available;
            atcBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
          }
        }

        function refreshOptions() {
          var sel = currentSelection();
          selects.forEach(function (selectEl, idx) {
            var partial = sel.slice();
            Array.prototype.forEach.call(selectEl.options, function (opt) {
              partial[idx] = opt.value;
              var anyMatch = poolVariants.some(function (v) {
                for (var j = 0; j < partial.length; j++) {
                  if (j === idx) {
                    if (v.options[j] !== opt.value) return false;
                  } else if (sel[j] != null && v.options[j] !== sel[j]) {
                    return false;
                  }
                }
                return v.available;
              });
              opt.disabled = !anyMatch;
            });
          });

          var match = findMatch(sel);
          if (!match) {
            var fallback = poolVariants.find(function (v) { return v.available; }) || poolVariants[0];
            if (fallback) {
              selects.forEach(function (selectEl, idx) {
                if (fallback.options[idx] != null) selectEl.value = fallback.options[idx];
              });
              match = fallback;
            }
          }
          setActiveVariant(match);
        }

        function formatMoney(cents) {
          var amount = (cents / 100).toFixed(2);
          var parts = amount.split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return '$' + parts.join('.');
        }

        selects.forEach(function (selectEl) {
          selectEl.addEventListener('change', refreshOptions);
        });

        refreshOptions();
      });
    }

    function boot() {
      document.querySelectorAll('[data-nc-fprov]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector) {
        var roots = e.target.querySelectorAll('[data-nc-fprov]');
        roots.forEach(initSection);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-derm-parallax-features"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.nc-pf');
    if (!sections.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (section) {
      var els = section.querySelectorAll('[data-nc-reveal]');

      if (prefersReduced) {
        els.forEach(function (el) { el.classList.add('nc-pf--visible'); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('nc-pf--visible');
          } else {
            e.target.classList.remove('nc-pf--visible');
          }
        });
      }, { threshold: 0.1 });

      els.forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-derm-pdp-crosssell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (!root || root.dataset.ncCrosssellInit === '1') return;
      root.dataset.ncCrosssellInit = '1';

      var cards = root.querySelectorAll('[data-pcard-card]');
      cards.forEach(function (card) {
        var optionsWrap = card.querySelector('[data-pcard-options]');
        var priceEl = card.querySelector('[data-pcard-price]');
        var atcBtn = card.querySelector('[data-pcard-atc]');
        var hiddenId = card.querySelector('[data-pcard-variant-id]');
        if (!optionsWrap || !hiddenId) return;

        var jsonEl = optionsWrap.querySelector('[data-pcard-variants]');
        if (!jsonEl) return;

        var allVariants = [];
        try {
          allVariants = JSON.parse(jsonEl.textContent);
        } catch (e) {
          return;
        }

        var safeIdsStr = optionsWrap.getAttribute('data-safe-ids') || '';
        var safeIds = safeIdsStr
          .split(',')
          .map(function (s) { return parseInt(s.trim(), 10); })
          .filter(function (n) { return !isNaN(n); });

        var poolVariants = allVariants.filter(function (v) {
          return safeIds.indexOf(v.id) !== -1;
        });
        if (poolVariants.length === 0) poolVariants = allVariants.slice();

        var selects = Array.prototype.slice.call(
          optionsWrap.querySelectorAll('[data-pcard-option-select]')
        );

        function currentSelection() {
          return selects.map(function (sel) { return sel.value; });
        }

        function findMatch(selection) {
          for (var i = 0; i < poolVariants.length; i++) {
            var v = poolVariants[i];
            var ok = true;
            for (var j = 0; j < selection.length; j++) {
              if (v.options[j] !== selection[j]) { ok = false; break; }
            }
            if (ok) return v;
          }
          return null;
        }

        function setActiveVariant(v) {
          if (!v) {
            if (atcBtn) {
              atcBtn.disabled = true;
              atcBtn.textContent = 'Unavailable';
            }
            return;
          }
          hiddenId.value = String(v.id);
          if (priceEl) priceEl.textContent = formatMoney(v.price);
          if (atcBtn) {
            atcBtn.disabled = !v.available;
            atcBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
          }
        }

        function refreshOptions() {
          var sel = currentSelection();
          selects.forEach(function (selectEl, idx) {
            var partial = sel.slice();
            Array.prototype.forEach.call(selectEl.options, function (opt) {
              partial[idx] = opt.value;
              var anyMatch = poolVariants.some(function (v) {
                for (var j = 0; j < partial.length; j++) {
                  if (j === idx) {
                    if (v.options[j] !== opt.value) return false;
                  } else if (sel[j] != null && v.options[j] !== sel[j]) {
                    return false;
                  }
                }
                return v.available;
              });
              opt.disabled = !anyMatch;
            });
          });

          var match = findMatch(sel);
          if (!match) {
            var fallback = poolVariants.find(function (v) { return v.available; }) || poolVariants[0];
            if (fallback) {
              selects.forEach(function (selectEl, idx) {
                if (fallback.options[idx] != null) selectEl.value = fallback.options[idx];
              });
              match = fallback;
            }
          }
          setActiveVariant(match);
        }

        function formatMoney(cents) {
          var amount = (cents / 100).toFixed(2);
          var parts = amount.split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return '$' + parts.join('.');
        }

        selects.forEach(function (selectEl) {
          selectEl.addEventListener('change', refreshOptions);
        });

        refreshOptions();
      });
    }

    function boot() {
      document.querySelectorAll('[data-nc-crosssell]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector) {
        var roots = e.target.querySelectorAll('[data-nc-crosssell]');
        roots.forEach(initSection);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-derm-web-agenda"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__ncWebCountdownInit) return;
    window.__ncWebCountdownInit = true;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function initCountdown(root) {
      if (root.dataset.ncCountdownReady === 'true') return;
      root.dataset.ncCountdownReady = 'true';

      var target = root.getAttribute('data-target');
      if (!target) return;

      var end = Date.parse(target);
      if (Number.isNaN(end)) return;

      var daysEl = root.querySelector('[data-nc-countdown-days]');
      var hoursEl = root.querySelector('[data-nc-countdown-hours]');
      var minutesEl = root.querySelector('[data-nc-countdown-minutes]');
      var secondsEl = root.querySelector('[data-nc-countdown-seconds]');

      function tick() {
        var diff = end - Date.now();
        if (diff < 0) diff = 0;

        var totalSeconds = Math.floor(diff / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      window.setInterval(tick, 1000);
    }

    function boot() {
      document.querySelectorAll('[data-nc-countdown]').forEach(initCountdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-derm-web-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nc-derm-web-hero__form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var first = form.querySelector('[data-nc-web-first]');
      var last = form.querySelector('[data-nc-web-last]');
      var full = form.querySelector('[data-nc-web-full-name]');
      var body = form.querySelector('[data-nc-web-body]');
      var phone = form.querySelector('input[name="contact[phone]"]');
      if (!full || !first || !last) return;
      full.value = (first.value + ' ' + last.value).trim();
      if (body) {
        var section = form.closest('[data-webinar-name]');
        var webinarName = section ? section.getAttribute('data-webinar-name') : 'Skin Social Series';
        body.value = 'Webinar registration: ' + webinarName + '\n'
          + 'Name: ' + full.value + '\n'
          + 'Phone: ' + (phone && phone.value ? phone.value : '—');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
